import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId : "us-east-1_g1jknw4L3",
    ClientId: "213l84bgpofl12nkgg6otvc71i"
}

export default new CognitoUserPool(poolData);